import React from "react";
import { Row, Col, Image, Card, Button, Form } from "react-bootstrap";
import ReportIllustraction from "../../../assets/images/report-illustration.svg";
import InsuranceLogo from "../../../assets/images/insurance-logos.svg";
import EstimateLogo from "../../../assets/images/estimate.svg";
import CaseBidLogo from "../../../assets/images/casebid.png";
import { ReactComponent as CaseBid } from "../../../assets/images/casebid.svg";

const DesktopAssessment = ({isDesktop=false,isInsurance=false,scheduleInspectionCalendly}) => {
  return (
    <Row>
      <Col>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <span className="details">
            {isInsurance ? (
              <>
                Curious to see if your <br />
                insurance will cover a new roof?
              </>
            ) : (
              <>
                Ready to explore your <br /> options for a brand new roof?
              </>
            )}
          </span>
          <span className="text-muted mt-3">
            {isInsurance ? (
              <>
                Work with us to qualify for a roof <br />
                replacement covered by your insurance
              </>
            ) : (
              <>
                Work with us to customize and <br /> install your beatiful new
                roof
              </>
            )}
          </span>
          {isInsurance ? (
            <Button
            onClick={()=>scheduleInspectionCalendly()}
            className=" btn-block report-card__request-quote-btn align-left mx-0 mt-4"
            //   style={isDesktop && { width: "170% !important" }}
            >
              Schedule Assessment
            </Button>
          ) : (
            <Button
              onClick={()=>scheduleInspectionCalendly()}
              className=" btn-block report-card__request-quote-consultantion-btn align-left mx-0 mt-4"
            //   style={isDesktop && { width: "170% !important" }}
            >
              {isDesktop
                ? "Schedule Consultation"
                : "Schedule Assessment"}
            </Button>
          )}
        </div>
      </Col>
      <Col>
        <Col>
          {/* {console.log(insurance_available, "SSSSS")} */}
          {isInsurance ? (
            <>
              <Col>
                <Image
                  className="toggle-img"
                  width="100%"
                  src={ReportIllustraction}
                />
              </Col>
              <Col>
                <Image
                  className="toggle-img"
                  width="100%"
                  src={InsuranceLogo}
                />
              </Col>
            </>
          ) : (
            <Col style={{ marginTop: isDesktop ? -25 : 0 }}>
              <Image className="toggle-img" width="100%" src={CaseBidLogo} />
            </Col>
          )}
        </Col>
      </Col>
    </Row>
  );
};
export default DesktopAssessment;
